import Headphones from 'components/icons/headphones';
import User from 'components/icons/user';
import { ItemUser } from 'data/firestore/globals';

export default function getAvatarIcon(createdBy?: ItemUser) {
    if (createdBy?.role === 'agent') return <Headphones />;
    return <User />;
}
